<template>
  <div class="modal fade" role="dialog" style="display:block;" tabindex="-1"
    :class="{ 'show': isOpen }" v-show="isOpen" @keyup.esc="strictOpen ? false : $emit('dismiss')" @click="checkClick($event)">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h3>{{ title }}</h3>
          </slot>
        </div>
        <div class="modal-body" style="padding: 25px">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn" v-if="!strictOpen"
              :class="dismissButtonOptions.class" @click="$emit('dismiss')">
              {{ dismissButtonOptions.label }}
            </button>
            <button type="button" class="btn"
              :class="actionButtonOptions.class" @click="$emit('submit')">
              {{ actionButtonOptions.label }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    actionButton: {
      type: Object
    },
    dismissButton: {
      type: Object
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    strictOpen: {
      type: Boolean,
      default: false
    },
    title: String
  },
  computed: {
    actionButtonOptions () {
      return {
        class: 'btn-primary',
        label: 'Confirm',
        disabled: false,
        dismiss: true,
        ...this.actionButton
      }
    },
    dismissButtonOptions () {
      return {
        class: 'btn-secondary',
        label: 'Dismiss',
        disabled: false,
        dismiss: true,
        ...this.dismissButton
      }
    }
  },
  mounted () {
    this.$el.focus()
  },
  methods: {
    checkClick (e) {
      // If a user clicks outside the area of dialog box then the dialog box disappears automatically - commented to avoid this behaviour
      // if (Array.from(e.target.classList).includes('modal')) {
      //   this.$emit('dismiss')
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Modal.vue